import { inject, Injectable, isDevMode } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { APP_CONFIG } from '../config/app-config.token';

declare let gtag: any;

@Injectable({
  providedIn: 'root',
})
export class GtagService {
  private router: Router = inject(Router);
  private config = inject(APP_CONFIG);

  initializeTracking() {
    if (!isDevMode()) {
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          gtag('config', 'G-PWSP8QSRKQ', {
            page_path: event.urlAfterRedirects,
          });
        }
      });
    }
  }

  trackEvent(eventCategory: string, eventAction: string, eventLabel: string = '') {
    if (this.config.production) {
      gtag('event', eventAction, {
        event_category: eventCategory,
        event_label: eventLabel,
      });
    }
  }
}
